import { StationEntity, StationFilter } from '../../models'

export const SET_STATIONS = 'SET_STATIONS'
export const SET_STATIONS_LOADED = 'SET_STATIONS_LOADED'
export const SET_STATION_FILTER = 'SET_STATION_FILTER'
export const SET_SELECTED_STATION = 'SET_SELECTED_STATION'

export interface StationState {
  stations: StationEntity[]
  isStationsLoaded: boolean
  stationFilter: StationFilter
  selectedStation?: StationEntity
}

interface SetStationFilterAction {
  type: typeof SET_STATION_FILTER
  payload: StationFilter
}

interface SetSelectedStationAction {
  type: typeof SET_SELECTED_STATION
  payload?: StationEntity
}

interface SetStationsAction {
  type: typeof SET_STATIONS
  payload: StationEntity[]
}

interface SetStationsLoadedAction {
  type: typeof SET_STATIONS_LOADED
  payload: boolean
}

export type StationAction =
  | SetStationFilterAction
  | SetSelectedStationAction
  | SetStationsAction
  | SetStationsLoadedAction
